import { Link } from "react-router-dom";
import type { Media } from "@/types/media";
import { formatViews } from "@/lib/media";

interface MediaCardProps {
  media: Media;
  showSynopsis?: boolean;
}

export default function MediaCard({ media, showSynopsis = false }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${media.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/50 bg-background-100/60 transition-colors duration-200 hover:border-primary-400/70"
    >
      <div className="relative w-full overflow-hidden pt-[150%]">
        <img
          src={media.poster}
          alt={`${media.title} 海报`}
          title={`${media.title} 在线观看`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/10 to-transparent opacity-80"></div>

        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-background-950/75 px-2 py-1 text-xs font-semibold text-accent-400 backdrop-blur">
          <i className="ri-star-fill text-[11px]"></i>
          {media.rating.toFixed(1)}
        </span>

        <span className="absolute right-2 top-2 rounded-md bg-primary-500/90 px-2 py-1 text-[11px] font-medium text-background-50 backdrop-blur">
          {media.kind === "movie" ? "电影" : "剧集"}
        </span>

        <div className="absolute inset-x-0 bottom-0 flex items-center gap-2 p-2.5">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <i className="ri-play-fill text-base"></i>
          </span>
          <span className="flex items-center gap-1 text-[11px] text-foreground-600">
            <i className="ri-fire-line"></i>
            {formatViews(media.views)}热度
          </span>
        </div>
      </div>

      <div className="p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-500">
          {media.title}
        </h3>
        <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
          <span className="truncate">{media.genres.slice(0, 2).join(" · ")}</span>
          <span className="shrink-0">{media.year}</span>
          {media.kind === "tv" && media.episodes && (
            <span className="shrink-0 text-primary-500">全{media.episodes}集</span>
          )}
        </div>
        {showSynopsis && (
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">
            {media.synopsis}
          </p>
        )}
      </div>
    </Link>
  );
}